import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { IconWeight } from '@nimbus-library/features/shared/directives/icon-weight.enum';

@Component({
  standalone: true,
  selector: 'app-footer-nar',
  templateUrl: './footer-nar.component.html',
  styleUrls: ['./footer-nar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, TranslateModule, SharedUIModule],
})
export class FooterNarComponent {
  @Input({ required: true }) public message: string;

  public readonly ICONS = ICONS;
  public readonly IconWeight = IconWeight;
  public readonly TranslationKeys = TranslationKeys;
}
